import { createIcon } from './icon-utils';

export const RemoveIcon = createIcon({
  path: 'M8.25 6.75H6V19.5c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75V6.75H8.25zm8.25-1.5h5.25a.75.75 0 1 1 0 1.5H19.5V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.75H2.25a.75.75 0 0 1 0-1.5H7.5V4.5a2.25 2.25 0 0 1 2.25-2.25h4.5A2.25 2.25 0 0 1 16.5 4.5v.75zm-1.5 0V4.5a.75.75 0 0 0-.75-.75h-4.5A.75.75 0 0 0 9 4.5v.75h6zM10.5 16.5a.75.75 0 1 1-1.5 0v-6a.75.75 0 1 1 1.5 0v6zm4.5 0a.75.75 0 1 1-1.5 0v-6a.75.75 0 1 1 1.5 0v6z',
});
